module.exports = __webpack_public_path__ + "img/img16.d87121a8.png";